export default import.meta.ROLLUP_FILE_URL_OpaYpr4ScR46eQuL$_iiEw